import { Icon } from '@chakra-ui/icons'
import { IconProps } from '@chakra-ui/react'
import { FC } from 'react'

interface VisaLogoProps extends IconProps {
  theme?: 'phthalo' | 'greenfit' | 'grayscale'
}

export const VisaLogo: FC<VisaLogoProps> = (props) => {
  const themeColors = (theme?: string) => {
    if (!theme) {
      return '#fff'
    }
    return theme === 'phthalo' ? '#ADEDD6' : theme === 'greenfit' ? '#B1F3A7' : '#fff'
  }

  return (
    <Icon width="64px" height="21px" fill="#ADEDD6" viewBox="0 0 64 21" {...props}>
      <path
        d="M33.1 6.894c-.037 2.786 2.565 4.34 4.525 5.265 2.014.948 2.69 1.556 2.683 2.405-.015 1.298-1.607 1.87-3.096 1.893-2.598.039-4.109-.679-5.31-1.222l-.936 4.238c1.205.538 3.436 1.007 5.75 1.027 5.431 0 8.985-2.594 9.004-6.617.02-5.105-7.297-5.388-7.247-7.67.017-.692.7-1.43 2.194-1.618.74-.095 2.783-.167 5.099.865l.909-4.1C45.43.92 43.829.5 41.835.5c-5.111 0-8.707 2.63-8.736 6.394ZM55.41.854c-.992 0-1.828.56-2.2 1.418L45.45 20.2h5.428l1.08-2.889h6.632l.627 2.889H64L59.826.853H55.41Zm.759 5.225 1.566 7.265h-4.29l2.724-7.265ZM26.519.853 22.241 20.2h5.172L31.689.853h-5.17Zm-7.65 0-5.384 13.168-2.177-11.196C11.052 1.575 10.043.853 8.923.853h-8.8L0 1.415c1.806.38 3.859.991 5.102 1.646.761.4.979.75 1.228 1.7l4.125 15.438h5.465L24.3.853h-5.432Z"
        fill={themeColors(props.theme)}
      />
    </Icon>
  )
}
